module.exports = __webpack_public_path__ + "static/media/ic_note.6bb2fc60.svg";